// ---------------------------------------------------------------------------
// First-run setup.
//
// No mock or sample data is seeded. Dental programs (and their school-fit info),
// the structured student profile, and the question bank are ALL generated on
// demand via the Codex CLI:
//   - Dental Programs  -> Codex builds each school's fit profile when added
//   - Student Profile  -> Codex extracts the structured profile from your inputs
//   - Question Bank    -> Codex (Program Research) finds program questions
//   - Answer Builder   -> Codex drafts personalized answers
//
// The only thing we seed are the editable Codex prompt templates, so the
// Prompts & Rubric screen has its starting content. Seeding is idempotent and
// per-template: a template added in a later app version (e.g. the fit-only
// agent) is inserted into existing databases without touching user edits.
// ---------------------------------------------------------------------------

import * as repo from './repository';
import { nowIso } from '../utils/id';
import { PROMPTS, PROMPT_VERSION } from '../ai/prompts';

export async function seedDatabaseIfNeeded(): Promise<void> {
  const existing = new Set(repo.listPromptTemplates().map((t) => t.id));
  for (const [key, def] of Object.entries(PROMPTS)) {
    const id = `tpl_${key}`;
    if (existing.has(id)) continue;
    repo.upsertPromptTemplate({
      id,
      agent: def.agent,
      version: PROMPT_VERSION,
      label: def.label,
      template: def.template,
      updatedAt: nowIso(),
    });
  }
  repo.markSeeded();
}
